/* ReactionTooltip.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./ReactionTooltip.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import Tooltip from '@atlaskit/tooltip';
import { FormattedMessage } from 'react-intl-next';
import { TOOLTIP_USERS_LIMIT } from '../../shared/constants';
import { messages } from '../../shared/i18n';
import { N90, N800, N0 } from '@atlaskit/theme/colors';
export var verticalMargin = 5;
var tooltipStyle = null;
var emojiNameStyle = null;
var footerStyle = null;
var underlineStyle = null;

/**
 * Test id for wrapper ReactionTooltip div
 */
export var RENDER_REACTIONTOOLTIP_TESTID = 'render-reactionTooltip';
export var ReactionTooltip = function ReactionTooltip(_ref) {
  var children = _ref.children,
    emojiName = _ref.emojiName,
    _ref$reaction$users = _ref.reaction.users,
    users = _ref$reaction$users === void 0 ? [] : _ref$reaction$users,
    _ref$maxReactions = _ref.maxReactions,
    maxReactions = _ref$maxReactions === void 0 ? TOOLTIP_USERS_LIMIT : _ref$maxReactions,
    _ref$isEnabled = _ref.isEnabled,
    isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled,
    allowUserDialog = _ref.allowUserDialog,
    handleOpenReactionsDialog = _ref.handleOpenReactionsDialog,
    dismissTooltip = _ref.dismissTooltip;
  var handleClick = function handleClick() {
    if (allowUserDialog && handleOpenReactionsDialog) {
      dismissTooltip();
      handleOpenReactionsDialog();
    }
  };
  var content = !users || users.length === 0 || !isEnabled ? null : /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    className: ax(["_1reo15vq _18m915vq _p12f1w81 _1bto1l2s _o5721q9c _otyr14y2 _d1n8glyw _102oidpf _1kvxidpf _1ysjidpf _17d4idpf _1hziidpf _3n4midpf _ltofidpf _k7zyidpf _1ywo1e5h _1pru15vq _u0h115vq _5qec1l2s _1eg614y2"])
  }, /*#__PURE__*/React.createElement("ul", null, emojiName ? /*#__PURE__*/React.createElement("li", {
    className: ax(["_1p1d1dk0 _syaz1lqe _k48p1pd9"]),
    style: {
      "--_14nrcaz": ix("var(--ds-text-inverse, ".concat(N90, ")"))
    }
  }, emojiName) : null, users.slice(0, maxReactions).map(function (user) {
    return /*#__PURE__*/React.createElement("li", {
      key: user.id
    }, user.displayName);
  }), /*#__PURE__*/React.createElement("li", {
    onMouseDown: handleClick,
    onClick: handleClick,
    className: ax(["_syaz1lqe", allowUserDialog && "_4bfu1r31 _1hms8stv _ajmmnqa1 _80omtlke _irr3pioe _30l31i9p"]),
    style: {
      "--_14nrcaz": ix("var(--ds-text-inverse, ".concat(N90, ")")),
      "--_yr7xfv": ix("var(--ds-background-neutral-bold, ".concat(N800, ")")),
      "--_ywovvi": ix("var(--ds-text-inverse, ".concat(N0, ")"))
    }
  }, users.length > maxReactions && /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.otherUsers, {
    values: {
      count: users.length - maxReactions
    }
  })))));
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: content,
    position: "bottom",
    testId: RENDER_REACTIONTOOLTIP_TESTID
  }, React.Children.only(children));
};